/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import RelaisSelfcareSimulationRecapMutation from '../graphql/mutations/RelaisSelfcareSimulationRecapMutation.js';

export const useRelaisSelfcareSimulationRecapMutation = () => {
  return useCommitMutation(RelaisSelfcareSimulationRecapMutation, { dataProp: 'relaisSelfcareSimulationRecap_M_simulation_recap' });
};

export default useRelaisSelfcareSimulationRecapMutation;
